export default function Logo({ onClick }) {
  return (
    <a
      href="#inicio"
      onClick={onClick}
      data-testid="logo-link"
      className="group flex items-center gap-3"
      aria-label="Realiza Engenharia — Início"
    >
      <img
        src="/logo-realiza.png"
        alt="Logo oficial da Realiza Engenharia"
        className="h-9 w-auto transition-transform duration-300 group-hover:scale-[1.03] sm:h-10"
        loading="eager"
      />
      <span className="hidden h-7 w-px bg-gold/40 sm:block" />
      <span className="hidden font-mono text-[9px] uppercase tracking-[0.4em] text-gold/90 sm:block">
        Engenharia
      </span>
    </a>
  );
}
